export default "__VITE_ASSET__CJbYeZoN__"